import { Box, Divider, Grid, Typography } from '@mui/material';
import { QuickListButton } from './QuickListButton'; // Import the custom button component
import { ActiveQuickListButton } from './ActiveQuickListButton';
import { AnnouncementState, QuickListItem, selectAnnouncementsState } from '../sagas/announcementSlice';
import { useSelector } from 'react-redux';
import { AnnouncementRecipientAlgorithms } from '@inosio/payments-sdk';
import { useEffect, useState } from 'react';
import { AnnouncementSectionProps } from '../validators/AnnouncementValidators';

const quickListItems: QuickListItem[] = [
  { value: AnnouncementRecipientAlgorithms.Tenants, label: 'All Current Tenants' },
  { value: AnnouncementRecipientAlgorithms.Owners, label: 'All Active Owners' },
];

interface IProps extends AnnouncementSectionProps {}

export const AnnouncementSendTo = (props: IProps) => {
  const { announcementDetail }: AnnouncementState = useSelector(selectAnnouncementsState);
  const [recipientOptions, setRecipientOptions] = useState<AnnouncementRecipientAlgorithms[]>([]);
  // Extract only the algorithm values from AnnouncementRecipientAlgorithms enum
  const algorithmValues = Object.values(AnnouncementRecipientAlgorithms);

  const handleQuickListSelect = (item: QuickListItem) => {
    const updatedRecipients = recipientOptions.some((selectedItem) => selectedItem === item.value)
      ? recipientOptions.filter((selectedItem) => selectedItem !== item.value) // Remove the item
      : [...recipientOptions, item.value]; // Add the item

    setRecipientOptions(updatedRecipients);
    props.setPendingAnnouncement({
      RecipientOptions: updatedRecipients,
    });
  };

  const handleRemoveQuickListItem = (item: QuickListItem) => {
    const updatedRecipients = recipientOptions.filter((selectedItem) => selectedItem !== item.value);
    setRecipientOptions(updatedRecipients);
    props.setPendingAnnouncement({
      RecipientOptions: updatedRecipients,
    });
  };

  useEffect(() => {
    const sendToAlgorithem = Array.isArray(announcementDetail.RecipientOptions)
      ? announcementDetail.RecipientOptions.map((recipient) => (algorithmValues.includes(recipient) ? recipient : recipient))
      : [];
    setRecipientOptions(sendToAlgorithem);
  }, [announcementDetail.RecipientOptions]);

  return (
    <Box sx={{ padding: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={8} sx={{ padding: '0px 10px 10px 10px' }}>
          <Typography sx={{ marginBottom: 2, fontSize: '16px', fontWeight: 'bold' }}>Select a Quick List:</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            {quickListItems.map((listItem) => (
              <QuickListButton key={listItem.value} item={listItem} selected={recipientOptions.includes(listItem.value)} onSelect={handleQuickListSelect} />
            ))}
          </Box>
          <Divider sx={{ margin: '10px 0px' }} />
        </Grid>

        <Grid item xs={4} borderLeft="2px solid #EEEEEE" minHeight="65vh">
          <Typography sx={{ marginBottom: 2, fontSize: '16px', fontWeight: 'bold' }}>Active Lists:</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {recipientOptions.map((value) => {
              // Find the corresponding QuickListItem for the algorithm value
              const listItem = quickListItems.find((item) => item.value === value);

              return listItem && <ActiveQuickListButton key={value} item={listItem} onRemove={handleRemoveQuickListItem} />;
            })}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
